import React from "react";

const ChatContactList = (props) => {
  return (
    <React.Fragment>
      <ul className="contacts">
        {props.contactList.length > 0 &&
          props.contactList.map((val) => {
            return (
              <React.Fragment key={Math.random(1, 9999)}>
                <li className="name-first-letter">{val.letter}</li>
                {val.contact.length > 0 &&
                  val.contact.map((innerVal) => {
                    return (
                      <li
                        className="active dlab-chat-user"
                        key={Math.random(1, 9999)}
                      >
                        <div className="d-flex bd-highlight">
                          <div className="img_cont">
                            <img
                              src={innerVal.image}
                              className="rounded-circle user_img"
                              alt=""
                            />
                            <span className="online_icon" />
                          </div>
                          <div className="user_info">
                            <span>{innerVal.name}</span>
                            <p>{innerVal.status}</p>
                          </div>
                        </div>
                      </li>
                    );
                  })}
              </React.Fragment>
            );
          })}
      </ul>
    </React.Fragment>
  );
};

export default ChatContactList;
